export class CompanyStatisticsOfActiveRecordsModel {
    public totalFacilities: number;
    public totalUnits: number;
    public totalWorkOrders: number;
    public totalUsers: number;
}
